import { Link } from 'react-router-dom';
import ContentPageLayout from 'components/ContentPageLayout';

export default function ReportingSystemPage() {
    return (
        <ContentPageLayout
            title="Belső visszaélés – bejelentési rendszer"
            subTitle="Biztonságos és bizalmas kapcsolatfelvétel a Fürge Diák Compliance Bizottságával."
            contentClassName="legal-content"
        >
                <div>
                    A Fürge Diák Iskolaszövetkezet létrehozta az Etikai Vonalat abból a célból, hogy a munkavállalók, a vállalattal szerződéses viszonyban lévő magán- vagy 
                    jogi személyek (pl. vevők, beszállítók), illetve bármely egyéb, a vállalat tevékenysége által érintett személyek bejelentést juttathassanak el közvetlenül a 
                    Compliance Bizottsághoz minden olyan ügyben, amely sérti a hatályos jogszabályokat, a vállalati belső szabályokat, vagy amely a vállalat Etikai 
                    Kódexének elveivel nem összeegyeztethető. Ilyen lehet például a korrupció, visszaélés, fogyasztói sérelem, tisztességtelen verseny, munkahelyi 
                    megfélemlítés, zaklatás, munkahelyi magatartási szabályok megsértése, összeférhetetlenség, pénzmosás, üzleti titokkal visszaélés, stb.
                    <br/>
                    <br/>
                    Vállalatunknál a Compliance Bizottság feladata a bejelentések fogadása, kezelése, és a szükséges intézkedések megtétele. A vizsgálatot a kijelölt 
                    Compliance Vizsgáló folytatja le a hatályos jogszabályi rendelkezések és a vállalat szabályzatában foglaltaknak megfelelően.
                    <br/>
                    <br/>
                    A bejelentés megtehető:
                    <br/>
                    <br/>
                    <ul className="list-disc pl-10">
                        <li>
                            Elektronikus formában, e-mailen keresztül a <strong><Link to={`mailto:compliance@furgediak.hu`} className='break-all hover:underline'>compliance@furgediak.hu</Link></strong> címen. A postafiók kizárólag a Compliance Bizottság által elérhető.
                        </li>
                        <li>
                            Telefonon a <Link to={`tel:+36 20 310 6246`} className='hover:underline'>+36(20)310-6246</Link> számon hétfőtől-péntekig 9 és 16 óra között, közvetlenül a Compliance Bizottságnak. Az anonim bejelentés akkor 
                            biztosított telefonon, ha a Bejelentő a hívószám kijelzését letiltja a hívás előtt.
                        </li>
                        <li>
                            Személyesen a Compliance Vizsgálóval előre egyeztetett időpontban, és helyen.
                        </li>
                        <li>
                            Írásban, postai levélben a Compliance Bizottságnak címezve az alábbi címen:
                            <br/>
                            Fürge Diák Iskolaszövetkezet
                            <br/>
                            „Compliance Bizottság részére felbontatlanul továbbítandó” megjelöléssel a
                            <br/>
                            1097 Budapest, Albert Flórián út 3/b címre.
                            <br/>
                            A Compliance Bizottságnak címzett levelek felbontatlanul kerülnek a címzetthez.
                        </li>
                    </ul>
                    <br/>
                    <br/>
                    Biztosítjuk az anonim bejelentés lehetőségét is, felhívjuk a figyelmet arra, hogy a bejelentés kivizsgálása mellőzhető, ha azonosíthatatlan személytől 
                    származik (kivéve, ha panasz vagy a közérdekű bejelentésnek súlyos jog- vagy érdeksérelem az alapja).
                    <br/>
                    <br/>
                    A Fürge Diák Iskolaszövetkezet garantálja a Bejelentő személyes adatainak védelmét, és azt, hogy az eljárás során a személyes adatok és a bejelentések 
                    kezelése az információs önrendelkezési jogról és az információszabadságról szóló 2011. évi CXII. törvény, a panaszokról, a közérdekű bejelentésekről, 
                    valamint a visszaélések bejelentésével összefüggő szabályokról szóló 2023. évi XXV. törvény rendelkezései szerint történik. Garantálja, hogy a 
                    jóhiszemű bejelentés miatt a Bejelentőt hátrányos jogkövetkemény nem érheti.
                    <br/>
                    <br/>
                    A személyes adatkezelés kizárólagos célja a kapott bejelentések összegyűjtése, áttekintése, kivizsgálása és megoldásuk nyomon követése. A 
                    személyes adatok csak azon időszak alatt használhatók, amely a fenti feladatok elvégzéséhez szükséges. A személyes adatok nem kerülnek 
                    felhasználásra semmilyen más célból, az adatkezelést kizárólag a Compliance Bizottság és szükség szerint – ha az a vizsgálat lefolytatása 
                    szempontjából indokolt és elengedhetetlen – a vizsgálatba bevont egyéb szervezet végzi. A Compliance Bizottság haladéktalanul törli a bejelentési 
                    rendszerből a bejelentésben nem érintett harmadik személyre vonatkozó, a bejelentés kivizsgálásához szükségtelen adatokat.
                </div>
        </ContentPageLayout>
    );
}
